export const HANDLE_GET_ANALYTICS = 'HANDLE_GET_ANALYTICS';
